<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>工单系统</el-breadcrumb-item>
            <el-breadcrumb-item>服务窗口</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item
          v-for="(item,index) in orderSeveiceList"
          :key="index"
          :title="item.ServiceName"
          :name="item.ServiceName"
        >
          <div style="text-align:left">{{item.SimpleDescribe}}</div>
          <h5 style="text-align:left">常见问题</h5>
          <div style="text-align:left">
            <el-button
              type="text"
              v-for="(p,pindex) in item.DefaultProblem"
              :key="pindex"
              @click="GetDefaultProblemAnswer(p)"
            >{{p.Problem}}</el-button>
          </div>
          <div style="text-align:right">
            <el-button type="primary" size="small" @click="InitAddOrderDetail(item)">以上都不能解决，发起人工工单</el-button>
          </div>
        </el-collapse-item>
      </el-collapse>
      <el-dialog
        width="50%"
        :title="defaultProblemTitle"
        :visible.sync="dialogDefaultProblemVisible"
        style="text-align:left"
      >
        <h5>描述</h5>
        <p>{{problem.SimpleDescribe}}</p>
        <h5>解决方案</h5>
        <p>{{problem.Answer}}</p>
      </el-dialog>
      <el-dialog width="50%" title="发起人工工单" :visible.sync="dialogAddOrderDetailVisible">
        <el-form :model="orderDetail" ref="orderDetailForm" :rules="orderDetailRules">
          <el-form-item label="工单标题" :label-width="formLabelWidth" prop="OrderTitle">
            <el-input size="small" v-model="orderDetail.OrderTitle" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="座位号" :label-width="formLabelWidth" prop="SeatNumber">
            <el-input size="small" v-model="orderDetail.SeatNumber" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="内容描述" :label-width="formLabelWidth" prop="ContentDescription">
            <el-input
              size="small"
              type="textarea"
              :rows="3"
              v-model="orderDetail.ContentDescription"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传图片" :label-width="formLabelWidth" prop="Picture">
            <el-upload
              action="http://eapi.ruizhiqi.cn/api/upload/uploadformdata"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              v-model="orderDetail.Picture"
              size="small"
              :on-success="uploadSuccess"
              :on-remove="onRemove"
              multiple
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="orderDetailOper">保存</el-button>
          <el-button size="small" @click="dialogAddOrderDetailVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="dialogImgPriviewVisible">
        <img width="100%" :src="dialogImageUrl" alt />
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import {
  GetOrderSerivceWin,
  GetOrderDefaultProblem,
  OrderDetailsAdd
} from "../../until/ZeusApiSDK/Logic/OrderServiceLogic";
import {
  GetCurrentUserInfo,
  GetGuid
} from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { Predicate } from "../../until/ZeusApiSDK/Model/Predicate";
import { GetSingeleUser } from "../../until/ZeusApiSDK/Logic/StructureLogic";
export default {
  data() {
    return {
      searchName: "",
      orderSeveiceList: [],
      activeName: "",
      dialogDefaultProblemVisible: false,
      defaultProblemTitle: "",
      currentUser: {},
      answer: "",
      dialogAddOrderDetailVisible: false,
      orderDetail: {},
      Pictures: [],
      problem:{},
      orderDetailRules: {
        //用户验证规则
        OrderTitle: [
          { required: true, message: "请输入工单标题", trigger: "blur" }
        ],
        ContentDescription: [
          { required: true, message: "请输入内容描述", trigger: "blur" }
        ],
        SeatNumber: [
          { required: true, message: "请输入座位号", trigger: "blur" }
        ]
      },
      formLabelWidth: "100px",
      dialogImgPriviewVisible: false,
      dialogImageUrl: ""
    };
  },
  created() {
    this.GetOrderService();
    this.currentUser = GetCurrentUserInfo();
  },
  methods: {
    GetOrderService: async function() {
      var res = await GetOrderSerivceWin();
      for (let s of res) {
        s.DefaultProblem = await GetOrderDefaultProblem(s.ID);
      }
      this.orderSeveiceList = res;
    },
    GetDefaultProblemAnswer: function(problem) {
      this.defaultProblemTitle = problem.Problem;
      this.dialogDefaultProblemVisible = true;
      this.problem = {};
      this.problem = problem;
    },
    InitAddOrderDetail: async function(service) {
      this.dialogAddOrderDetailVisible = true;
      var id = await GetGuid();
      this.orderDetail = {};
      this.orderDetail.ID = id;
      this.orderDetail.OrderServiceWinID = service.ID;
      this.orderDetail.SubmitterID = this.currentUser.UserId;
      this.orderDetail.SubmitterName = this.currentUser.TrueName;
      this.orderDetail.OrderState = 0;
      var userNameArr = this.currentUser.UserName.split("@");
      if (this.UserName != "admin") {
        this.orderDetail.SubmitterEntID = userNameArr[0];
      } else {
        this.orderDetail.SubmitterEntID = "guoyifei";
      }
      var dealer = service.DealPerson;
      var dealerArr = JSON.parse(dealer);
      var DealPersonEntIDArr = [];
      for (let d of dealerArr) {
        DealPersonEntIDArr.push(d.EntID);
      }
      this.orderDetail.DealPersonEntIDArr = JSON.stringify(DealPersonEntIDArr);
    },
    uploadSuccess: function(res) {
      if (this.Pictures.indexOf(res.Data.Message) == -1) {
        this.Pictures.push(res.Data.Message);
      }
    },
    onRemove: function(file, filelist) {
      this.Pictures.splice(
        this.Pictures.indexOf(file.response.Data.Message),
        1
      );
    },
    orderDetailOper: function() {
      this.$refs["orderDetailForm"].validate(valid => {
        this.orderDetail.Picture = this.Pictures.join(",");
        OrderDetailsAdd(this.orderDetail).then(res => {
          if (res == "success") {
            this.$message({
              message: "添加成功",
              type: "success",
              center: true
            });
            this.dialogAddOrderDetailVisible = false;
          } else {
            this.$message({
              message: "添加失败",
              type: "warning",
              center: true
            });
          }
        });
      });
    },
    handlePictureCardPreview: function(file) {
      this.dialogImageUrl = file.url;
      this.dialogImgPriviewVisible = true;
    }
  }
};
</script>
<style>
.sub {
  font-size: 12px;
  color: #8f8d8d;
  /* margin-top: 10px; */
}
</style>